
import React from 'react';
import { PremiumBotsList } from '@/components/admin/premium-bots/PremiumBotsList';
import { PremiumBotStatsCards } from '@/components/admin/premium-bots/PremiumBotStatsCards';
import { useIsMobile } from '@/hooks/use-mobile';
import { cn } from '@/lib/utils';

const PremiumBotManagementPage = () => {
  const isMobile = useIsMobile();
  
  return (
    <div className="space-y-4 md:space-y-6">
      <div>
        <h1 className={cn("font-bold tracking-tight", isMobile ? "text-xl" : "text-2xl")}>
          Premium Bots Management
        </h1>
        <p className="text-muted-foreground text-sm md:text-base">
          Manage your premium bots, add new ones or edit existing ones.
        </p>
      </div>
      
      {/* Stats Overview */}
      <PremiumBotStatsCards />
      
      <PremiumBotsList />
    </div>
  );
};

export default PremiumBotManagementPage;
